import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import numeral from 'numeral';

import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';

import { setPortal } from 'modules/portal';
import { paramConverter, refineValue } from 'modules/common';

import {
  aiCategoryList,
  goodsinfoAdverList,
  aiCategoryProductList,
  aiCategoryCategoryList,
  aiCategoryAllItemList,
  aiCategoryProductListCount,
  aiCategoryCategoryListCount,
} from 'lib/api/goods';
import { getHeadObj, dataConverter } from 'lib/commonLib';

import Avatar from 'components/atoms/Avatar';
import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import CurrentStatus from 'components/atoms/CurrentStatus';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewPopoverWrap from 'components/molecules/NewPopoverWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import AutoComplete from 'components/molecules/NewSelectBox/AutoComplete';
import MbTabs from 'components/organisms/MbTabs';
import Modal from 'components/organisms/NewModal';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';

const useStyles = makeStyles((theme) => ({
  filterInput: {
    width: 150,
  },
  popoverWrap: {
    padding: 10,
  },
  cateNameInput: { width: '100% !important', margin: '10px 0 10px 5px' },
  autoCompleteWrap: {
    marginTop: 10,
  },
  autoComplete: {
    width: '100%',
    marginBottom: 10,
  },
  productWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 auto',
    '& > div': {
      width: 150,
      '& > p:last-child': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
    '&  p': {
      margin: 0,
    },
  },
  modalProductWrap: {
    position: 'relative',
    height: 300,
    width: 1050,
    '& > div > div': {
      display: 'flex',
      flexWrap: 'wrap',
      margin: '0 auto',
      '& > div': {
        '& > p:last-child': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },

        '&.moreLoading': {
          width: '100%',
        },
      },
    },
  },
  productItem: {
    width: 150,
    '&  p': {
      margin: 0,
      textAlign: 'left',
    },
  },
  dimming: {
    zIndex: theme.zIndex.table.dimming,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100% !important',
    height: '100%',
    backgroundColor: 'rgb(255 255 255 / 0.6)',
  },
}));

const AiCategoryProduct = ({ type, location }) => {
  const isProductPage = type === 'product';
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  let initParams = {
    pltfomTpCode: '01',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    ctgrDepth1: null,
    ctgrDepth2: null,
    ctgrDepth3: null,
    ctgrDepth4: null,
    ctgrDepth5: null,
  };
  let initCategoryParams = {
    ctgrDepth1: null,
    ctgrDepth2: null,
    ctgrDepth3: null,
    ctgrDepth4: null,
    ctgrDepth5: null,
  };
  const convertParamsKeys = [
    'sDate',
    'eDate',
    'adverId',
    'pltfomTpCode',
    'ctgrDepth1',
    'ctgrDepth2',
    'ctgrDepth3',
    'ctgrDepth4',
    'ctgrDepth5',
    'ctgrType',
    'ctgrAll',
  ];
  const convertCtgrKeys = [
    'ctgrDepth1',
    'ctgrDepth2',
    'ctgrDepth3',
    'ctgrDepth4',
    'ctgrDepth5',
  ];
  const customConvertKeys = [
    'sDate',
    'eDate',
    'adverId',
    'pltfomTpCode',
    'ctgrType',
    'ctgrAll',
  ];

  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertParamsKeys
  );
  const newInitCategoryParams = dataConverter(
    queryString.parse(location.search),
    convertCtgrKeys
  );
  const isPopPage = queryString.parse(location.search).isPop === '1';
  if (!isProductPage) {
    initParams = {
      ...initParams,
      ...newInitParams,
      sort: 'desc',
      order: 'GOODS_CTGR_CNT',
    };
    if (!isPopPage || (isPopPage && initParams.ctgrAll === undefined)) {
      initParams.ctgrAll = '01';
    }

    initCategoryParams = {
      ...initCategoryParams,
      ...newInitCategoryParams,
    };
  }

  const [initialization, setInitialization] = useState(false);

  const [params, setParams] = useState(initParams);

  const [categoryParams, setCategoryParams] = useState(initCategoryParams);
  const [tempParams, setTempParams] = useState(initParams);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [adverList, setAdverList] = useState([]);
  const [listCount, setListCount] = useState(0);

  const [categoryList, setCategoryList] = useState({
    ctgrDepth1: { data: [] },
    ctgrDepth2: { data: [] },
    ctgrDepth3: { data: [] },
    ctgrDepth4: { data: [] },
    ctgrDepth5: { data: [] },
  });
  const [allItemData, setAllItemData] = useState({});
  const [allItemPage, setAllItemPage] = useState(1);

  const [categorySelected, setCategorySelected] = useState(false);
  const [categoryLabel, setCategoryLabel] = useState('');
  const [hasCategoryVal, setHasCategoryVal] = useState(
    !!initParams['ctgrDepth1'] ||
      !!initParams['ctgrDepth2'] ||
      !!initParams['ctgrDepth3'] ||
      !!initParams['ctgrDepth4'] ||
      !!initParams['ctgrDepth5'] ||
      !!initParams['ctgrNm'] ||
      !!initParams['adverId']
  );

  const [tabState, setTabState] = useState('productName');

  const initModal = {
    open: false,
    params: {},
  };
  const [modal, setModal] = useState(initModal);

  const initSnackbar = {
    open: false,
    variant: '',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);

  useEffect(() => {
    if (isPopPage && !!params.ctgrNm) {
      aiCategoryCategoryListCount({ ...tempParams, ...categoryParams })
        .then((response) => {
          const { data } = response.data;
          setListCount(data.totalCnt);
        })
        .catch((error) => {
          setSnackbar({
            ...initSnackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    goodsinfoAdverList({ pltfomTpCode: tempParams.pltfomTpCode })
      .then((response) => {
        const { data } = response.data;
        setAdverList(data);
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      });
    // eslint-disable-next-line
  }, [tempParams.pltfomTpCode]);

  useEffect(() => {
    let newTempParams = { ...tempParams };

    if (!!tempParams['ctgrNm']) {
      newTempParams = {
        ...newTempParams,
        ctgrType: '01',
      };
    } else if (
      !!categoryParams['ctgrDepth1'] ||
      !!categoryParams['ctgrDepth2'] ||
      !!categoryParams['ctgrDepth3'] ||
      !!categoryParams['ctgrDepth4'] ||
      !!categoryParams['ctgrDepth5']
    ) {
      newTempParams = {
        ...newTempParams,
        ctgrType: '02',
      };
    } else {
      delete newTempParams['ctgrType'];
    }
    if (JSON.stringify(newTempParams) !== JSON.stringify(tempParams)) {
      setTempParams(newTempParams);
    }
    if (
      !categoryParams['ctgrDepth1'] &&
      !categoryParams['ctgrDepth2'] &&
      !categoryParams['ctgrDepth3'] &&
      !categoryParams['ctgrDepth4'] &&
      !categoryParams['ctgrDepth5'] &&
      !tempParams['ctgrNm']
    ) {
      setCategorySelected(false);
    } else {
      setCategorySelected(true);
      let resultLabel = [];
      for (let item of [
        categoryParams['ctgrDepth1'],
        categoryParams['ctgrDepth2'],
        categoryParams['ctgrDepth3'],
        categoryParams['ctgrDepth4'],
        categoryParams['ctgrDepth5'],
        tempParams['ctgrNm'],
      ]) {
        if (!!item) {
          resultLabel.push('#', item, ' ');
          setCategoryLabel(resultLabel);
        }
      }
    }

    // eslint-disable-next-line
  }, [tempParams, categoryParams]);

  useEffect(() => {
    aiCategoryList({ ...paramConverter(categoryParams) })
      .then((response) => {
        const { data } = response.data;
        setCategoryList(data);
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      });

    // eslint-disable-next-line
  }, [categoryParams]);

  useEffect(() => {
    let newParams = { ...tempParams };
    delete newParams['ctgrDepth1'];
    delete newParams['ctgrDepth2'];
    delete newParams['ctgrDepth3'];
    delete newParams['ctgrDepth4'];
    delete newParams['ctgrDepth5'];
    delete newParams['ctgrNm'];
    setTempParams(newParams);
    // eslint-disable-next-line
  }, [tabState]);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
    setTempParams(initParams);
    setCategoryParams(initCategoryParams);
    setHasCategoryVal(false);
    if (isPopPage && window.location.search !== '?isPop=1&ctgrType=01') {
      window.location.replace(
        window.location.pathname + '?isPop=1&ctgrType=01'
      );
    }
  };

  /**
   * 페이지 파라미터를 관리하는 params 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setHasCategoryVal(
        !!categoryParams['ctgrDepth1'] ||
          !!categoryParams['ctgrDepth2'] ||
          !!categoryParams['ctgrDepth3'] ||
          !!categoryParams['ctgrDepth4'] ||
          !!categoryParams['ctgrDepth5'] ||
          !!tempParams['ctgrNm'] ||
          !!tempParams['adverId']
      );
      setParams(newParams);
    }
  };

  const handleCategory = (newCategory) => {
    if (JSON.stringify(categoryParams) !== JSON.stringify(newCategory)) {
      setCategoryParams(newCategory);
    }
  };

  const handleTempParams = (newParams, name) => {
    if (name === 'ctgrAll' && newParams[name] === '02') {
      const newTempParams = { ...newParams };
      delete newTempParams['ctgrNm'];
      setTempParams(newTempParams);
    }
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  const handleAllItems = (params) => {
    let newParams = { ...params };
    for (let key in params) {
      if (!params[key]) {
        delete newParams[key];
      }
    }
    setAllItemPage(1);
    aiCategoryAllItemList({ ...newParams, page: 1, limit: 70 })
      .then((response) => {
        const { data } = response.data;
        setAllItemData(data);
        setModal({
          ...modal,
          open: true,
          params: params,
        });
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      });
  };

  /**
   * popover를 열어주는 state 관리
   * 팝오버를 사용하기위한 버튼을 클릭했을때는 닫히고 열리고 모두 가능해야하기때문에 toggle로 사용
   */
  const handleToggleOpen = () => {
    setCategoryOpen(!categoryOpen);
    if (tabState === 'productName' && tempParams.ctgrAll === '02') {
      setSnackbar({
        ...initSnackbar,
        open: true,
        variant: 'info',
        message: t(
          '전체보기가 OFF인 상태에서는 카테고리명 검색을 할 수 없습니다.'
        ),
      });
    }
  };
  /**
   * 모달 데이터 변경했을 때 실행되는 함수
   * @param newData
   * @param name
   */
  const handleInput = (newData, name) => {
    let newParams = {
      ...tempParams,
      ...newData,
    };
    if (newParams[name] === '') {
      delete newParams[name];
    }
    setTempParams(newParams);
  };

  const handleSubmit = () => {
    getParam({ ...tempParams, ...categoryParams });

    if (isProductPage) {
      if (tempParams.adverId !== null && tempParams.adverId !== undefined) {
        aiCategoryProductListCount({ ...tempParams, ...categoryParams })
          .then((response) => {
            const { data } = response.data;
            setListCount(data.totalCnt);
          })
          .catch((error) => {
            setSnackbar({
              ...initSnackbar,
              open: true,
              variant: 'error',
              message: error,
            });
          });
      } else {
        setSnackbar({
          ...initSnackbar,
          open: true,
          variant: 'error',
          message: t('광고주ID가 없습니다.'),
        });
        setListCount(0);
      }
    } else {
      if (
        !categoryParams['ctgrDepth1'] &&
        !categoryParams['ctgrDepth2'] &&
        !categoryParams['ctgrDepth3'] &&
        !categoryParams['ctgrDepth4'] &&
        !categoryParams['ctgrDepth5'] &&
        !tempParams['ctgrNm'] &&
        !tempParams['adverId']
      ) {
        setSnackbar({
          ...initSnackbar,
          open: true,
          variant: 'error',
          message: t('광고주ID 혹은 카테고리를 선택하세요.'),
        });
        setListCount(0);
      } else {
        aiCategoryCategoryListCount({ ...tempParams, ...categoryParams })
          .then((response) => {
            const { data } = response.data;
            setListCount(data.totalCnt);
          })
          .catch((error) => {
            setSnackbar({
              ...initSnackbar,
              open: true,
              variant: 'error',
              message: error,
            });
          });
      }
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    USER_ID: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'USER_ID').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        return rowObj['USER_ID'] !== 'total' && rowObj['USER_ID'];
      },
      bodyStyle: {
        textAlign: 'center',
      },
      orderFlag: false,
    },
    IMAGE_URL: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'IMAGE_URL').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        return <Avatar src={rowObj['IMAGE_URL']} />;
      },
    },
    GOODS_CTGR_NM: {
      makeHead: (headsMap) => {
        return <>depth1</>;
      },
      makeBody: (rowObj, headsMap) => {
        let addParams = dataConverter(
          { ...params, adverId: rowObj['USER_ID'], ctgrType: '02' },
          customConvertKeys,
          'string'
        );
        const showWindowUrl =
          '/product/collection/aiCategory/category?isPop=1' + addParams;
        return rowObj['USER_ID'] !== 'total' &&
          rowObj['GOODS_CTGR_NM'] !== '' ? (
          <IconAreaWrap
            text={rowObj['GOODS_CTGR_NM']}
            icon="faExternalLink"
            toolTipTitle={rowObj['GOODS_CTGR_NM']}
            onClick={() =>
              handlePortalUrl(
                showWindowUrl + '&ctgrDepth1=' + rowObj['GOODS_CTGR_NM']
              )
            }
          />
        ) : (
          <p style={{ textAlign: 'center' }}>{rowObj['GOODS_CTGR_NM']}</p>
        );
      },
      orderFlag: !isProductPage && !!params.adverId,
    },
    GOODS_CTGR_NM2: {
      makeHead: (headsMap) => {
        return <>depth2</>;
      },
      makeBody: (rowObj, headsMap) => {
        let addParams = dataConverter(
          { ...params, adverId: rowObj['USER_ID'], ctgrType: '02' },
          customConvertKeys,
          'string'
        );
        const showWindowUrl =
          '/product/collection/aiCategory/category?isPop=1' + addParams;
        return rowObj['USER_ID'] !== 'total' &&
          rowObj['GOODS_CTGR_NM2'] !== '' ? (
          <IconAreaWrap
            text={rowObj['GOODS_CTGR_NM2']}
            icon="faExternalLink"
            toolTipTitle={rowObj['GOODS_CTGR_NM2']}
            onClick={() =>
              handlePortalUrl(
                showWindowUrl +
                  '&ctgrDepth1=' +
                  rowObj['GOODS_CTGR_NM'] +
                  '&ctgrDepth2=' +
                  rowObj['GOODS_CTGR_NM2']
              )
            }
          />
        ) : (
          <p style={{ textAlign: 'center' }}>{rowObj['GOODS_CTGR_NM2']}</p>
        );
      },
      orderFlag: !isProductPage && !!params.adverId,
    },
    GOODS_CTGR_NM3: {
      makeHead: (headsMap) => {
        return <>depth3</>;
      },
      makeBody: (rowObj, headsMap) => {
        let addParams = dataConverter(
          { ...params, adverId: rowObj['USER_ID'], ctgrType: '02' },
          customConvertKeys,
          'string'
        );
        const showWindowUrl =
          '/product/collection/aiCategory/category?isPop=1' + addParams;
        return rowObj['USER_ID'] !== 'total' &&
          rowObj['GOODS_CTGR_NM3'] !== '' ? (
          <IconAreaWrap
            text={rowObj['GOODS_CTGR_NM3']}
            icon="faExternalLink"
            toolTipTitle={rowObj['GOODS_CTGR_NM3']}
            onClick={() =>
              handlePortalUrl(
                showWindowUrl +
                  '&ctgrDepth1=' +
                  rowObj['GOODS_CTGR_NM'] +
                  '&ctgrDepth2=' +
                  rowObj['GOODS_CTGR_NM2'] +
                  '&ctgrDepth3=' +
                  rowObj['GOODS_CTGR_NM3']
              )
            }
          />
        ) : (
          <p style={{ textAlign: 'center' }}>{rowObj['GOODS_CTGR_NM3']}</p>
        );
      },
      orderFlag: !isProductPage && !!params.adverId,
    },
    GOODS_CTGR_NM4: {
      makeHead: (headsMap) => {
        return <>depth4</>;
      },
      makeBody: (rowObj, headsMap) => {
        let addParams = dataConverter(
          { ...params, adverId: rowObj['USER_ID'], ctgrType: '02' },
          customConvertKeys,
          'string'
        );
        const showWindowUrl =
          '/product/collection/aiCategory/category?isPop=1' + addParams;
        return rowObj['USER_ID'] !== 'total' &&
          rowObj['GOODS_CTGR_NM4'] !== '' ? (
          <IconAreaWrap
            text={rowObj['GOODS_CTGR_NM4']}
            icon="faExternalLink"
            toolTipTitle={rowObj['GOODS_CTGR_NM4']}
            onClick={() =>
              handlePortalUrl(
                showWindowUrl +
                  '&ctgrDepth1=' +
                  rowObj['GOODS_CTGR_NM'] +
                  '&ctgrDepth2=' +
                  rowObj['GOODS_CTGR_NM2'] +
                  '&ctgrDepth3=' +
                  rowObj['GOODS_CTGR_NM3'] +
                  '&ctgrDepth4=' +
                  rowObj['GOODS_CTGR_NM4']
              )
            }
          />
        ) : (
          <p style={{ textAlign: 'center' }}>{rowObj['GOODS_CTGR_NM4']}</p>
        );
      },
      orderFlag: !isProductPage && !!params.adverId,
    },
    GOODS_CTGR_NM5: {
      makeHead: (headsMap) => {
        return <>depth5</>;
      },
      makeBody: (rowObj, headsMap) => {
        let addParams = dataConverter(
          { ...params, adverId: rowObj['USER_ID'], ctgrType: '02' },
          customConvertKeys,
          'string'
        );
        const showWindowUrl =
          '/product/collection/aiCategory/category?isPop=1' + addParams;
        return rowObj['USER_ID'] !== 'total' &&
          rowObj['GOODS_CTGR_NM5'] !== '' ? (
          <IconAreaWrap
            text={rowObj['GOODS_CTGR_NM5']}
            icon="faExternalLink"
            toolTipTitle={rowObj['GOODS_CTGR_NM5']}
            onClick={() =>
              handlePortalUrl(
                showWindowUrl +
                  '&ctgrDepth1=' +
                  rowObj['GOODS_CTGR_NM'] +
                  '&ctgrDepth2=' +
                  rowObj['GOODS_CTGR_NM2'] +
                  '&ctgrDepth3=' +
                  rowObj['GOODS_CTGR_NM3'] +
                  '&ctgrDepth4=' +
                  rowObj['GOODS_CTGR_NM4'] +
                  '&ctgrDepth5=' +
                  rowObj['GOODS_CTGR_NM5']
              )
            }
          />
        ) : (
          <p style={{ textAlign: 'center' }}>{rowObj['GOODS_CTGR_NM5']}</p>
        );
      },
      orderFlag: !isProductPage && !!params.adverId,
    },
    GOODS_CTGR_LIST: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'GOODS_CTGR_LIST').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <div className={classes.productWrap}>
            {(() => {
              let result = [];
              let tempIndex = 0;
              for (let item of rowObj['GOODS_CTGR_LIST']) {
                result.push(
                  <div key={tempIndex++} className={classes.productItem}>
                    <Link
                      href="#"
                      onClick={(e) => handlePortalUrl(item['URL'])}
                    >
                      <Avatar
                        alt={item['name'] + ' 이미지'}
                        src={item['IMAGE_URL']}
                      />
                      {/*;*/}
                      {/*<Avatar*/}
                      {/*  variant="rounded"*/}
                      {/*  style={{*/}
                      {/*    width: 120,*/}
                      {/*    height: 120,*/}
                      {/*    margin: '0 auto',*/}
                      {/*    fontSize: 10,*/}
                      {/*  }}*/}
                      {/*>*/}
                      {/*  {(typeof rowObj['IMAGE_URL'] === 'undefined' ||*/}
                      {/*    rowObj['IMAGE_URL'] === '') &&*/}
                      {/*    'No img'}*/}
                      {/*</Avatar>*/}
                    </Link>
                    <p style={{ textAlign: 'left' }}>{item['PCODE']}</p>
                    <p title={item['PNM']}>{item['PNM']}</p>
                  </div>
                );
              }
              return result;
            })()}
          </div>
        );
      },
    },
    URL: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'URL').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <p
            style={{
              width: 200,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            title={rowObj['URL']}
          >
            {rowObj['URL']}
          </p>
        );
      },
    },
    GOODS_CTGR_CNT: {
      makeBody: (rowObj, headsMap) => {
        return (
          <p
            style={{
              textAlign: 'center',
            }}
          >
            {rowObj['GOODS_CTGR_CNT']}
          </p>
        );
      },
      orderFlag: !isProductPage && !!params.adverId,
    },
    STD_CTGR_NO: {
      merged: true,
    },
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        return data['USER_ID'] !== 'total' ? (
          <IconAreaWrap>
            {isProductPage ? (
              <NewButton
                title={t('상품보기')}
                icon="faHome"
                iconBtn
                onClick={(e) => handlePortalUrl(data['URL'])}
              />
            ) : (
              <NewButton
                title={t('전체 상품 보기')}
                icon="faImages"
                iconBtn
                onClick={() =>
                  handleAllItems({
                    sDate: params.sDate,
                    eDate: params.eDate,
                    pltfomTpCode: params.pltfomTpCode,
                    adverId: data['USER_ID'],
                    ctgrDepth1: data.GOODS_CTGR_NM,
                    ctgrDepth2: data.GOODS_CTGR_NM2,
                    ctgrDepth3: data.GOODS_CTGR_NM3,
                    ctgrDepth4: data.GOODS_CTGR_NM4,
                    ctgrDepth5: data.GOODS_CTGR_NM5,
                  })
                }
              />
            )}
          </IconAreaWrap>
        ) : (
          'total'
        );
      },
    });
    return result;
  })();

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };

  const handleClose = () => {
    setModal({ ...modal, open: false, params: {} });
    setAllItemPage(1);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={handleTempParams}
          params={tempParams}
          useDisplayFilter={false}
          useExternalFilter={false}
          pltfomTpCodeFixed={['01', '02']}
        />
        <AutoComplete
          list={adverList}
          label={t('광고주ID')}
          name="adverId"
          valueKey="USER_ID"
          labelKey="USER_ID"
          getParam={handleTempParams}
          params={tempParams}
          className={classes.filterInput}
        />
        {isProductPage ? (
          <>
            <NewInput
              label={t('상품코드')}
              type="filter"
              name="prdtCode"
              params={tempParams}
              value={tempParams['prdtCode']}
              callBack={handleInput}
              className={classes.filterInput}
            />
            <NewInput
              label={t('상품명')}
              type="filter"
              name="prdtNm"
              params={tempParams}
              value={tempParams['prdtNm']}
              callBack={handleInput}
              className={classes.filterInput}
            />
          </>
        ) : (
          <FilterCollection
            label={t('카테고리 전체보기')}
            name="ctgrAll"
            type="radio"
            labelKey="labe"
            valueKey="value"
            list={[
              { labe: 'ON', value: '01' },
              { labe: 'OFF', value: '02' },
            ]}
            params={tempParams}
            callBack={handleTempParams}
          />
        )}
        <NewPopoverWrap
          label={'상품 카테고리'}
          open={categoryOpen}
          selectedLabel={categoryLabel}
          filtered={categorySelected}
          onClick={handleToggleOpen}
          filterList={
            <div className={classes.popoverWrap}>
              <MbTabs
                isMenuTab={false}
                params={params}
                name="categorySearch"
                initValue="categoryClass"
                getCurTab={(cur) => {
                  setTabState(cur);
                  setCategoryParams(initCategoryParams);
                  const newTempParams = { ...tempParams };
                  delete newTempParams['ctgrNm'];
                  setTempParams(newTempParams);
                  if (
                    !isProductPage &&
                    !!tempParams['ctgrAll'] &&
                    tempParams.ctgrAll === '02' &&
                    cur === 'productName'
                  ) {
                    setSnackbar({
                      ...initSnackbar,
                      open: true,
                      variant: 'info',
                      message: t(
                        '전체보기가 OFF인 상태에서는 카테고리명 검색을 할 수 없습니다.'
                      ),
                    });
                  }
                }}
                tabMenuList={(() => {
                  const result = new Map();
                  result.set('categoryClass', {
                    menuUrl: 'categoryClass',
                    menuSeq: 'categoryClass',
                    menuNm: t('카테고리분류'),
                  });
                  result.set('productName', {
                    menuUrl: 'productName',
                    menuSeq: 'productName',
                    menuNm: t('카테고리명'),
                  });
                  return result;
                })()}
                tabs={{
                  categoryClass: {
                    tabComponent: (
                      <CategoryClass
                        params={categoryParams}
                        list={categoryList}
                        getParam={handleCategory}
                        isPopPage={isPopPage}
                      />
                    ),
                  },
                  productName: {
                    tabComponent: (
                      <NewInput
                        label={t('카테고리명')}
                        type="filter"
                        name="ctgrNm"
                        params={tempParams}
                        value={tempParams['ctgrNm']}
                        callBack={handleInput}
                        className={classes.cateNameInput}
                        disabled={
                          tempParams.ctgrAll === '02' ||
                          params.ctgrAll === '02' ||
                          isPopPage
                        }
                      />
                    ),
                  },
                }}
                isModal={true}
              />
            </div>
          }
        />
        <NewButton type="filterButton" onClick={handleSubmit}>
          {t('확인')}
        </NewButton>
      </NewFilterWrap>
      {isProductPage &&
        (params.adverId !== null && params.adverId !== undefined ? (
          <NewTableContainer
            dataReqPromise={aiCategoryProductList}
            params={params}
            getParam={getParam}
            customized={customized}
            addColumnList={addColumnList}
            useTotal={false}
            useSearch={false}
            useExcel={false}
            title={
              listCount > 0 &&
              t('총') + ' ' + numeral(listCount).format() + t('개')
            }
            reFetchHead
          />
        ) : (
          <CurrentStatus type="noTable" />
        ))}
      {!isProductPage && (
        <>
          {hasCategoryVal ? (
            <NewTableContainer
              dataReqPromise={aiCategoryCategoryList}
              params={params}
              getParam={getParam}
              customized={customized}
              addColumnList={addColumnList}
              useTotal={!!params.adverId}
              useSearch={false}
              useExcel={false}
              title={
                listCount > 0 &&
                t('총') + ' ' + numeral(listCount).format() + t('개')
              }
              reFetchHead
            />
          ) : (
            <CurrentStatus type="noTable" />
          )}
        </>
      )}

      <Modal
        open={modal.open}
        headerTitle={t('전체 상품 보기')}
        handleClose={handleClose}
        confirmBtnOpen={false}
        cancelBtnTitle={t('확인')}
      >
        <AllProductsPopup
          data={allItemData}
          handlePortalUrl={handlePortalUrl}
          allItemPage={allItemPage}
          setAllItemPage={setAllItemPage}
          setAllItemData={setAllItemData}
          modal={modal}
        />
      </Modal>

      <SnackbarWrap
        open={snackbar.open}
        onClose={handleSnackBarClose}
        variant={snackbar.variant}
        message={snackbar.message}
      />
    </>
  );
};

const CategoryClass = (props) => {
  const { params, list, getParam } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  return list['ctgrDepth1'].data.length > 0 ? (
    <div className={classes.autoCompleteWrap}>
      {(() => {
        const result = [];
        for (let i = 1; i < 6; i++) {
          result.push(
            <AutoComplete
              key={i}
              list={list['ctgrDepth' + i].data}
              label={i + t('차 카테고리')}
              name={'ctgrDepth' + i}
              valueKey="CODE_VAL"
              labelKey="CODE_VAL"
              getParam={getParam}
              params={params}
              className={classes.autoComplete}
              allValue={null}
              disabled={list['ctgrDepth' + i].data[0].length === 0}
            />
          );
        }
        return result;
      })()}
    </div>
  ) : (
    <p style={{ textAlign: 'center' }}>카테고리 정보를 불러오지 못했습니다.</p>
  );
};

const AllProductsPopup = (props) => {
  const {
    handlePortalUrl,
    data,
    allItemPage,
    setAllItemPage,
    setAllItemData,
    modal,
  } = props;
  const { info, list } = data;
  const { t } = useTranslation();
  const classes = useStyles();

  const initSnackbar = {
    open: false,
    variant: '',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);
  const [moreLoading, setMoreLoading] = useState(false);

  useEffect(() => {
    if (allItemPage !== 1) {
      setMoreLoading(true);
      aiCategoryAllItemList({
        ...refineValue(modal.params),
        page: allItemPage,
        limit: 70,
      })
        .then((response) => {
          const { data } = response.data;
          if (data.length !== 0) {
            const newList = [...list, ...data.list];
            setAllItemData({
              info: info,
              list: newList,
            });
          } else {
            setSnackbar({
              ...initSnackbar,
              open: true,
              variant: 'info',
              message: t('추가 데이터가 없습니다.'),
            });
          }
        })
        .catch((error) => {
          setSnackbar({
            ...initSnackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          setMoreLoading(false);
        });
    }
    // eslint-disable-next-line
  }, [allItemPage]);

  const handleTableScroll = (event) => {
    const { scrollHeight, scrollTop, clientHeight } = event.currentTarget;
    if (scrollTop !== 0 && scrollHeight === scrollTop + clientHeight) {
      setAllItemPage(allItemPage + 1);
    }
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };

  return (
    <>
      {info !== undefined ? (
        <h5 style={{ marginTop: 0, fontSize: 15, textALign: 'left' }}>
          {t('광고주')} : {info['USER_ID']}
          <br />
          {t('카테고리')} : {info['GOODS_CTGR_NM']}
          {!!info['GOODS_CTGR_NM2'] && ' > ' + info['GOODS_CTGR_NM2']}
          {!!info['GOODS_CTGR_NM3'] && ' > ' + info['GOODS_CTGR_NM3']}
          {!!info['GOODS_CTGR_NM4'] && ' > ' + info['GOODS_CTGR_NM4']}
          {!!info['GOODS_CTGR_NM5'] && ' > ' + info['GOODS_CTGR_NM5']}
        </h5>
      ) : (
        t('광고주 데이터 없음.')
      )}

      {list !== undefined ? (
        <div className={clsx(classes.modalProductWrap)}>
          <Scrollbars
            autoHide
            autoHideTimeout={1000}
            autoHideDuration={200}
            onScroll={(e) => {
              handleTableScroll(e);
            }}
          >
            {(() => {
              let result = [];
              let tempIndex = 0;
              for (let item of list) {
                result.push(
                  <div key={tempIndex++} className={classes.productItem}>
                    <Link
                      href="#"
                      onClick={(e) => handlePortalUrl(item['URL'])}
                    >
                      <Avatar
                        alt={item['name'] + ' 이미지'}
                        src={item['IMAGE_URL']}
                      />
                      {/*<Avatar*/}
                      {/*  variant="rounded"*/}
                      {/*  */}
                      {/*  style={{*/}
                      {/*    width: 120,*/}
                      {/*    height: 120,*/}
                      {/*    margin: '0 auto',*/}
                      {/*    fontSize: 10,*/}
                      {/*  }}*/}
                      {/*>*/}
                      {/*  {(typeof item['IMAGE_URL'] === 'undefined' ||*/}
                      {/*    item['IMAGE_URL'] === '') &&*/}
                      {/*    'No img'}*/}
                      {/*</Avatar>*/}
                    </Link>
                    <p>{item['PCODE']}</p>
                    <p title={item['PNM']}>{item['PNM']}</p>
                  </div>
                );
              }
              return result;
            })()}
          </Scrollbars>
          {moreLoading && (
            <div className={classes.dimming}>
              <CurrentStatus type="moreLoading" />
            </div>
          )}
        </div>
      ) : (
        t('상품 데이터 없음')
      )}
      <SnackbarWrap
        open={snackbar.open}
        onClose={handleSnackBarClose}
        variant={snackbar.variant}
        message={snackbar.message}
      />
    </>
  );
};

export default withRouter(AiCategoryProduct);
